import "./FilterCommon.css";

const ContentStack = ({children, paddingTop}) => (
    <div className={"content-stack"} style={{paddingTop}}>
        {children}
    </div>
);

export default ContentStack;